import React, {CSSProperties, PropsWithChildren} from "react";
import {useServices} from "../../../../hooks/use-services.hook";

interface BoardingPassFieldValueComponentProps extends PropsWithChildren {
    styles?: CSSProperties;
}
export const BoardingPassFieldValueComponent: React.FC<BoardingPassFieldValueComponentProps> = (props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: "flex",
        fontSize: theme.fontSize.h6,
        fontWeight: theme.fontWeight.semiBold,
        ...props.styles
    };

    return (
        <div style={styles}>
            {props.children}
        </div>
    );
}
